module.exports = __webpack_public_path__ + "img/g-logo.f6ce5696.svg";